import { render } from "./AntepostEventsList.vue?vue&type=template&id=45c379c8&scoped=true"
import script from "./AntepostEventsList.vue?vue&type=script&lang=js"
export * from "./AntepostEventsList.vue?vue&type=script&lang=js"

import "./AntepostEventsList.vue?vue&type=style&index=0&id=45c379c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45c379c8"]])

export default __exports__